import React from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

const DeleteConfirmDialog = ({ 
  open,
  type, // 'state' | 'transition'
  itemName,
  constraints = [],
  canDelete = true,
  onConfirm,
  onCancel
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onCancel}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center space-x-2">
            <AlertTriangle className="w-5 h-5 text-yellow-500" />
            <span>Delete {type === 'state' ? 'State' : 'Transition'}?</span>
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3 pt-2">
            <p>
              Are you sure you want to delete <span className="font-mono text-white">{itemName}</span>?
            </p>

            {!canDelete && (
              <div className="bg-red-500/10 border border-red-500/30 rounded p-3 text-sm">
                <p className="font-semibold text-red-400 mb-2">Cannot delete:</p>
                <ul className="space-y-1 text-xs">
                  {constraints.map((constraint, idx) => (
                    <li key={idx} className="flex items-start space-x-2">
                      <span className="text-red-400">•</span>
                      <span className="text-gray-300">{constraint}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {canDelete && constraints.length > 0 && (
              <div className="bg-yellow-500/10 border border-yellow-500/30 rounded p-3 text-sm">
                <p className="font-semibold text-yellow-400 mb-2">This will also:</p>
                <ul className="space-y-1 text-xs">
                  {constraints.map((constraint, idx) => (
                    <li key={idx} className="flex items-start space-x-2">
                      <span className="text-yellow-400">•</span>
                      <span className="text-gray-300">{constraint}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          {canDelete && (
            <Button 
              variant="destructive" 
              onClick={onConfirm}
              data-testid="confirm-delete"
            >
              Delete
            </Button>
          )}
          {!canDelete && (
            <Button onClick={onCancel}>
              Close
            </Button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteConfirmDialog;
